import { createAsyncThunk } from "@reduxjs/toolkit";

//Include Both Helper File with needed methods
import {
  getDirectContact as getDirectContactApi,
  getMessages as getMessagesApi,
  getChannels as getChannelsApi,
  addMessage as addMessageApi,
  deleteMessage as deleteMessageApi,
} from "../../helpers/fakebackend_helper";

// WhatsApp Integration
import whatsappService from "../../services/whatsappService";

export const getDirectContact = createAsyncThunk("chat/getDirectContact", async () => {
  try {
    const response = getDirectContactApi();
    return response;
  } catch (error) {
    return error;
  }
});

export const getChannels = createAsyncThunk("chat/getChannels" , async () => {
  try{
    const response = getChannelsApi();
    return response;
  }catch (error) {
    return error;
  }
});

export const getMessages = createAsyncThunk("chat/getMessages" , async (roomId:any) => {
  try{
    const response = getMessagesApi(roomId);
    const data = await response;
    return data;
  }catch (error) {
    return error;
  }
});

export const addMessage = createAsyncThunk("chat/addMessage" , async (message:any) => {
  try{
    const response = addMessageApi(message);
    const data = await response;
    return data;
  }catch (error) {
    return error;
  }
});

export const deleteMessage = createAsyncThunk("chat/deleteMessage" , async (message : any) => {
  try{
    const response = deleteMessageApi(message);
    const data = await response;
    return data;
  }catch (error) {
    return error;
  }
});

// WhatsApp Integration Thunks
export const getWhatsAppConversations = createAsyncThunk(
  "chat/getWhatsAppConversations",
  async ({ channel, onlyUnread }: { channel?: string; onlyUnread?: boolean } = {}) => {
    try {
      const result = await whatsappService.getConversations(channel, onlyUnread);
      if (result.success) {
        return result.data;
      }
      throw new Error(result.message || 'Failed to fetch WhatsApp conversations');
    } catch (error: any) {
      throw error;
    }
  }
);

export const getWhatsAppMessages = createAsyncThunk(
  "chat/getWhatsAppMessages",
  async ({ conversationId, pageNumber = 1, pageSize = 50 }: { conversationId: string; pageNumber?: number; pageSize?: number }) => {
    try {
      const result = await whatsappService.getMessages(conversationId, pageNumber, pageSize);
      if (result.success) {
        return result.data;
      }
      throw new Error(result.message || 'Failed to fetch WhatsApp messages');
    } catch (error: any) {
      throw error;
    }
  }
);

export const sendWhatsAppMessage = createAsyncThunk(
  "chat/sendWhatsAppMessage",
  async (messageData: {
    conversationId: string;
    content: string;
    recipientPhoneNumber: string;
    senderId: string;
    mediaType?: 'None' | 'Image' | 'Document' | 'Audio' | 'Video';
    mediaUrl?: string;
  }) => {
    try {
      const result = await whatsappService.sendMessage(messageData);
      if (result.success) {
        return result.data;
      }
      throw new Error(result.message || 'Failed to send WhatsApp message');
    } catch (error: any) {
      throw error;
    }
  }
);